// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1375":"9d6c4215","3271":"e8397013","3315":"a18b4bf5","3637":"dad5e56e","4205":"7a29801d","4242":"98f00c33","8853":"6f75a1cb","9300":"d1bb8049"}[chunkId] + ".chunk.css";
};